import React from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import Breadcrumb from "../../components/Breadcrumb";
import DashBoardLayerOne from "../../components/DashBoardLayerOne";
import CategoriesTable from "../../components/CategoryManagement/CategoriesTable";
import SubCategoriesTable from "../../components/CategoryManagement/SubCategoriesTable";
import SubCategoryTableV2 from "../../components/CategoryManagement/SubCategoryTableV2";


const SubCategoriesManagement = () => {
    return (
        <>
            {/* MasterLayout */}
            <MasterLayout>
                {/* Breadcrumb */}
                <Breadcrumb title="Sub Categories" />

                {/* <SubCategoriesTable /> */}
                <SubCategoryTableV2/>
                {/* DashBoardLayerOne */}
                {/* <DashBoardLayerOne /> */}

            </MasterLayout>
        </>
    );
};

export default SubCategoriesManagement;
